import { Pipe, PipeTransform } from '@angular/core';
import { CustomFieldValue } from '../../models/custom-field.model';

/** {{ row.customFields | cfValue: field.id }} → the display value of one custom field ('' if none). */
@Pipe({ name: 'cfValue' })
export class CfValuePipe implements PipeTransform {
  transform(values: CustomFieldValue[], fieldId: number): string {
    const value = (values || []).find(v => v.fieldId === fieldId);
    return value && value.displayValue ? value.displayValue : '';
  }
}
